<template>
  <tippy delay="500">
    <slot></slot>

    <template v-slot:content>
      <div
        style="min-width: 18.5rem"
        class="p-5 bg-white border border-gray-200 shadow-lg rounded-md space-y-2"
      >
        <div class="flex items-center space-x-3">
          <a :href="fandom.path" target="_blank">
            <img
              :src="fandom.avatar_url"
              class="rounded-full h-12 w-12"
            />
          </a>
          <div class="text-black font-medium text-lg">
            <a :href="fandom.path" target="_blank">
              a/{{ fandom.slug }}
            </a>
          </div>
        </div>
        <div class="w-full grid grid-cols-12 gap-1">
            <div class="col-span-6 flex items-center space-x-1">
              <div class="text-base text-black font-medium">{{ fandom.total_member_count }}</div>
              <div class="text-base text-gray-700 font-normal">Members</div>
            </div>
            <div class="border-l border-gray-200 pl-2 col-span-6 flex items-center space-x-1">
              <div class="text-base text-black font-medium">{{ fandom.online_member_count }}</div>
              <div class="text-base text-gray-700 font-normal">Online</div>
            </div>
        </div>
        <div>
          <div class="text-sm text-gray-700 font-normal pt-1 line-clamp-2">
            {{ fandom.description }}
          </div>
        </div>
        <div class="pt-2">
          <fandom-joiner :fandom='fandom'
                         classes='px-5 py-2 text-lg rounded-md'>
          </fandom-joiner>
        </div>
      </div>
    </template>
  </tippy>
</template>

<script>
export default {
  props: {
    fandom: Object
  },
}
</script>